var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderSearchBarIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.66 6.869c0 3.13-2.565 5.667-5.728 5.667S1.205 9.999 1.205 6.869s2.564-5.667 5.727-5.667c3.163 0 5.727 2.537 5.727 5.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.023 10.917l1.363 1.146.887 1.89 4.5 4.047 1.099-1.493-4.27-3.794M12.455 12.13l2.25.659"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderSearchBarIc);
export default __webpack_public_path__ + "static/media/provider-search-bar-ic.f0d88d4117ae79a7a588937d8b93b816.svg";
export { ForwardRef as ReactComponent };